import * as yup from 'yup';

const oAuthValidation = yup.object().shape({
  loginKey: yup.string().required(),
  loginProvider: yup.string().required(),
  password: yup.string().required(),
});

export default oAuthValidation;
